<div class="modal-header">
    <h4 class="modal-title">Datos Votación</h4>
    <button type="button" class="close" aria-label="Close" (click)="dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <div class="row">

        <div id="stepperForm" class="bs-stepper col-md-12">
            <div class="bs-stepper-header">
                <div class="step" data-target="#test-l-1">
                    <button class="step-trigger">
                        <span class="bs-stepper-circle">1</span>
                        <span class="bs-stepper-label">Datos de la Votación</span>
                    </button>
                </div>
                <div class="line"></div>
                <div class="step" data-target="#test-l-2">
                    <button class="step-trigger">
                        <span class="bs-stepper-circle">2</span>
                        <span class="bs-stepper-label">Participantes</span>
                    </button>
                </div>
                <div class="line"></div>
                <div class="step" data-target="#test-l-3">
                    <button class="step-trigger">
                        <span class="bs-stepper-circle">3</span>
                        <span class="bs-stepper-label">Boleta de la Votación</span>
                    </button>
                </div>
            </div>
            <div class="bs-stepper-content">
                <form [formGroup]="form" (ngSubmit)="accept()" novalidate>
                    <div id="test-l-1" class="content col-md-12">
                        <div class="card-body table-responsive table-hover p-0"
                            style="height: auto; max-height: 600px; padding-bottom: 20px !important;">
                            <table class="table table-bordered table-head-fixed">
                                <thead>
                                    <tr>
                                        <th scope="col" width="30%">Campo</th>
                                        <th scope="col" width="70%">Contenido</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Titulo</td>
                                        <td>{{form.controls.titulo.value}}</td>
                                    </tr>
                                    <tr>
                                        <td>Fecha de Inicio</td>
                                        <td>{{form.controls.fechaInicio.value | date: 'dd/MM/yyyy'}}</td>
                                    </tr>
                                    <tr>
                                        <td>Fecha de Término</td>
                                        <td>{{form.controls.fechaTermino.value | date: 'dd/MM/yyyy'}}</td>
                                    </tr>
                                    <tr>
                                        <td>Descripción</td>
                                        <td>{{form.controls.descripcion.value}}</td>
                                    </tr>
                                    <tr>
                                        <td>Estatus</td>
                                        <td>
                                            <div *ngIf="form.controls.estatus.value.id === 1; else info">
                                                <span class="badge bg-info">{{form.controls.estatus.value.name}}</span>
                                            </div>
                                            <ng-template #info>
                                                <div>
                                                    <span
                                                        class="badge bg-info">{{form.controls.estatus.value.name}}</span>
                                                </div>
                                            </ng-template>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Hash de Votantes</td>
                                        <td>
                                            <a [routerLink]="" class="table-btn-row">
                                                <span class="badge bg-success"> <i class="fa fa-thumbs-up mr-1"
                                                        aria-hidden="true"></i>Sellar Lista de Votantes</span>
                                            </a>
                                            {{form.controls.llavePublica.value | slice:0:10}}...
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Hash de Boleta</td>
                                        <td>
                                            <a [routerLink]="" class="table-btn-row">
                                                <span class="badge bg-success"> <i class="fa fa-thumbs-up mr-1"
                                                        aria-hidden="true"></i>Sellar Boleta</span>
                                            </a>
                                            {{form.controls.llavePublica.value | slice:0:10}}...
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Hash de Votación</td>
                                        <td>
                                            <span class="badge bg-warning"><i class="fa fa-exclamation mr-1"
                                                    aria-hidden="true"></i>Se deben sellar la boleta y la lista de
                                                votantes</span><br>
                                            <a [routerLink]="" class="table-btn-row">
                                                <span class="badge bg-success"> <i class="fa fa-thumbs-up mr-1"
                                                        aria-hidden="true"></i>Sellar Votación</span>
                                            </a>
                                            {{form.controls.llavePublica.value | slice:0:10}}...
                                        </td>
                                    </tr>
                            </table>
                        </div>
                        <button type="button" class="btn btn-danger col-md-6" (click)="dismiss()">
                            <i class="fa fa-times-circle"></i>
                            Cancelar
                        </button>
                        <button type="button" class="btn btn-info col-md-6" (click)="next()">
                            <i class="fa fa-arrow-circle-right"></i>
                            Siguiente
                        </button>
                    </div>
                    <div id="test-l-2" class="content col-md-12">
                        <div class="form-group col-md-12">
                            <button type="button" class="btn btn-success col-md-6">
                                <i class="fa fa-upload"></i>
                                Cargar Archivo
                            </button>
                            <button type="button" class="btn btn-danger col-md-6">
                                <i class="fa fa-trash"></i>
                                Eliminar Votantes
                            </button>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-6">
                                <label for="email">Correo electrónico</label>
                                <input type="email" class="form-control" id="email" formControlName="email"
                                    [ngClass]="{ 'is-invalid': submitted && form.controls.email.errors }">
                                <div *ngIf="submitted && form.controls.email.errors" class="invalid-feedback">
                                    <div *ngIf="form.controls.email.errors.required">Campo requerido</div>
                                    <div *ngIf="form.controls.email.errors.email">Email invalido</div>
                                </div>
                            </div>
                            <div class="fix-form-group col-md-6">
                                <button type="button" class="btn btn-info col-md-12">
                                    <i class="fa fa-plus"></i>
                                    Agregar Votante
                                </button>
                            </div>
                        </div>
                        <div class="card-body table-responsive table-hover p-0"
                            style="height: auto; max-height: 600px; padding-bottom: 20px !important;">
                            <table class="table table-bordered table-head-fixed">
                                <thead>
                                    <tr>
                                        <th scope="col" width="80%">Votante</th>
                                        <th scope="col" width="20%">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Votante 1</td>
                                        <td>
                                            <div>
                                                <a [routerLink]="" title="Eliminar" class="table-btn-row custom-icon">
                                                    <i class="fa fa-trash mr-1" aria-hidden="true"></i>
                                                </a>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Votante 2</td>
                                        <td>
                                            <div>
                                                <a [routerLink]="" title="Eliminar" class="table-btn-row custom-icon">
                                                    <i class="fa fa-trash mr-1" aria-hidden="true"></i>
                                                </a>
                                            </div>
                                        </td>
                                    </tr>
                            </table>
                        </div>
                        <button type="button" class="btn btn-info col-md-6" (click)="previous()">
                            <i class="fa fa-arrow-circle-left"></i>
                            Atrás
                        </button>
                        <button type="button" class="btn btn-info col-md-6" (click)="next()">
                            <i class="fa fa-arrow-circle-right"></i>
                            Siguiente
                        </button>
                    </div>
                    <div id="test-l-3" class="content col-md-12">
                        <div class="row">
                            <div class="form-group col-md-12">
                                <label for="pregunta">Pregunta</label>
                                <input type="text" class="form-control" id="pregunta" formControlName="pregunta"
                                    [ngClass]="{ 'is-invalid': submitted && form.controls.pregunta.errors }">
                                <div *ngIf="submitted && form.controls.pregunta.errors" class="invalid-feedback">
                                    <div *ngIf="form.controls.pregunta.errors.required">Campo requerido</div>
                                </div>
                            </div>

                            <div class="form-group col-md-6">
                                <label for="estatus1">Elegir entre</label>
                                <select class="form-control" id="estatus1" formControlName="estatus"
                                    [ngClass]="{ 'is-invalid': submitted && form.controls.estatus.errors }">
                                    <div *ngIf="submitted && form.controls.estatus.errors" class="invalid-feedback">
                                        <div *ngIf="form.controls.estatus.errors.required">Campo requerido</div>
                                    </div>
                                    <option *ngFor="let item of comboList" [ngValue]="item">{{item.name}}</option>
                                </select>
                            </div>

                            <div class="form-group col-md-6">
                                <label for="estatus2">y</label>
                                <select class="form-control" id="estatus2" formControlName="estatus"
                                    [ngClass]="{ 'is-invalid': submitted && form.controls.estatus.errors }">
                                    <div *ngIf="submitted && form.controls.estatus.errors" class="invalid-feedback">
                                        <div *ngIf="form.controls.estatus.errors.required">Campo requerido</div>
                                    </div>
                                    <option *ngFor="let item of comboList" [ngValue]="item">{{item.name}}</option>
                                </select>
                            </div>

                            <div class="form-group col-md-12">
                                <div class="icheck-primary d-inline">
                                    <input type="checkbox" class="form-check-input" id="permitirVotoNulo"
                                        formControlName="permitirVotoNulo">
                                    <label for="permitirVotoNulo">Permitir voto nulo</label>
                                </div>
                            </div>

                            <div class="form-group">
                                <button type="button" class="btn btn-info col-md-12">
                                    <i class="fa fa-plus"></i>
                                    Agregar Pregunta
                                </button>
                            </div>
                        </div>
                        <div class="card-body table-responsive table-hover p-0"
                            style="height: auto; max-height: 600px; padding-bottom: 20px !important;">
                            <table class="table table-bordered table-head-fixed">
                                <thead>
                                    <tr>
                                        <th scope="col" width="80%">Pregunta</th>
                                        <th scope="col" width="20%">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Pregunta 1<br><small>Se puede elegir como minimo 1 y 2
                                                opciones</small><br><small>Voto nulo: si</small>
                                            <div class="card-body table-responsive table-hover p-0"
                                                style="height: auto; max-height: 600px; padding-bottom: 20px !important;">
                                                <table class="table table-bordered table-head-fixed">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col" width="80%">Opción</th>
                                                            <th scope="col" width="20%">Acciones</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>Opción 1</td>
                                                            <td>
                                                                <div>
                                                                    <a [routerLink]="" title="Modificar"
                                                                        class="table-btn-row custom-icon">
                                                                        <i class="fas fa-edit mr-1"
                                                                            aria-hidden="true"></i>
                                                                    </a>
                                                                    <a [routerLink]="" title="Eliminar"
                                                                        class="table-btn-row custom-icon">
                                                                        <i class="fa fa-trash mr-1"
                                                                            aria-hidden="true"></i>
                                                                    </a>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Opción 2</td>
                                                            <td>
                                                                <div>
                                                                    <a [routerLink]="" title="Modificar"
                                                                        class="table-btn-row custom-icon">
                                                                        <i class="fas fa-edit mr-1"
                                                                            aria-hidden="true"></i>
                                                                    </a>
                                                                    <a [routerLink]="" title="Eliminar"
                                                                        class="table-btn-row custom-icon">
                                                                        <i class="fa fa-trash mr-1"
                                                                            aria-hidden="true"></i>
                                                                    </a>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                </table>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <a [routerLink]="" title="Modificar" class="table-btn-row custom-icon">
                                                    <i class="fas fa-edit mr-1" aria-hidden="true"></i>
                                                </a>
                                                <a [routerLink]="" title="Eliminar" class="table-btn-row custom-icon">
                                                    <i class="fa fa-trash mr-1" aria-hidden="true"></i>
                                                </a>
                                                <a [routerLink]="" title="Agregar Opción"
                                                    class="table-btn-row custom-icon">
                                                    <i class="fa fa-plus mr-1" aria-hidden="true"></i>
                                                </a>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Pregunta 2<br><small>Se puede elegir como minimo 1 y 3
                                                opciones</small><br><small>Voto nulo: no</small>
                                            <div class="card-body table-responsive table-hover p-0"
                                                style="height: auto; max-height: 600px; padding-bottom: 20px !important;">
                                                <table class="table table-bordered table-head-fixed">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col" width="80%">Opción</th>
                                                            <th scope="col" width="20%">Acciones</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>Opción 1</td>
                                                            <td>
                                                                <div>
                                                                    <a [routerLink]="" title="Modificar"
                                                                        class="table-btn-row custom-icon">
                                                                        <i class="fas fa-edit mr-1"
                                                                            aria-hidden="true"></i>
                                                                    </a>
                                                                    <a [routerLink]="" title="Eliminar"
                                                                        class="table-btn-row custom-icon">
                                                                        <i class="fa fa-trash mr-1"
                                                                            aria-hidden="true"></i>
                                                                    </a>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Opción 2</td>
                                                            <td>
                                                                <div>
                                                                    <a [routerLink]="" title="Modificar"
                                                                        class="table-btn-row custom-icon">
                                                                        <i class="fas fa-edit mr-1"
                                                                            aria-hidden="true"></i>
                                                                    </a>
                                                                    <a [routerLink]="" title="Eliminar"
                                                                        class="table-btn-row custom-icon">
                                                                        <i class="fa fa-trash mr-1"
                                                                            aria-hidden="true"></i>
                                                                    </a>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                </table>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <a [routerLink]="" title="Modificar" class="table-btn-row custom-icon">
                                                    <i class="fas fa-edit mr-1" aria-hidden="true"></i>
                                                </a>
                                                <a [routerLink]="" title="Eliminar" class="table-btn-row custom-icon">
                                                    <i class="fa fa-trash mr-1" aria-hidden="true"></i>
                                                </a>
                                                <a [routerLink]="" title="Agregar Opción"
                                                    class="table-btn-row custom-icon">
                                                    <i class="fa fa-plus mr-1" aria-hidden="true"></i>
                                                </a>
                                            </div>
                                        </td>
                                    </tr>
                            </table>
                        </div>
                        <button type="button" class="btn btn-info col-md-6" (click)="previous()">
                            <i class="fa fa-arrow-circle-left"></i>
                            Atrás
                        </button>
                        <button type="submit" class="btn btn-success col-md-6">
                            <i class="fa fa-check-circle"></i>
                            Aceptar
                        </button>
                    </div>
                </form>
            </div>
        </div>

    </div>
</div>